import React, { useMemo, useState, useRef } from 'react';
import './style.scss';
import PropTypes from 'prop-types';
import PrescriptionBadge from 'components/HealthRecords/Prescriptions/PrescriptionBadge';
import PrescriptionDetails from 'components/HealthRecords/Prescriptions/PrescriptionDetails';
import PerformanceUtils from 'services/PerformanceUtils';
import { MyList } from 'components/Common/ListWithDetails/view';
import ResponsiveColumns from 'components/ResponsiveColumns';

const PrescriptionsList = (props) => {
  const navigateTo = useRef();
  const [selected, setSelected] = useState();

  const refills = useMemo(() => {
    return PerformanceUtils.sortBy(props.refills || []).filter(
      ({ status }) => status === 'pending',
    );
  }, [props.refills]);

  const prescriptions = useMemo(() => {
    return PerformanceUtils.sortBy(props.prescriptions || []);
  }, [props.prescriptions]);

  function onSelect(item) {
    setSelected(item);
    setTimeout(() => {
      navigateTo.current?.(1);
    });
  }

  return (
    <div className="row full-width full-height list-with-details responsive-directory prescription-list">
      <ResponsiveColumns
        ref={navigateTo}
        columns={[
          {
            name: 'list',
            element: (
              <div className="full-height-panel underside-right-panel scroll-list list">
                {!props.hideRequests && (
                  <>
                    <span className="small-title padded-title">Pending Refill Requests</span>
                    <MyList
                      items={refills}
                      isSelected={(item) => item?.id === selected?.id}
                      renderBadge={(item) => <PrescriptionBadge item={item} />}
                      selectItem={onSelect}
                    />
                  </>
                )}
                <span className="small-title padded-title">Prescriptions</span>
                <MyList
                  items={prescriptions}
                  isSelected={(item) => item?.id === selected?.id}
                  renderBadge={(item) => <PrescriptionBadge item={item} />}
                  selectItem={onSelect}
                />
              </div>
            ),
          },
          selected
            ? {
                name: 'Detail',
                element:
                  !!selected &&
                  (props.renderDetails ? (
                    props.renderDetails(selected)
                  ) : (
                    <PrescriptionDetails
                      key={selected?.id}
                      title={selected?.prescription_id ? 'Refill Request' : undefined}
                      prescription={selected}
                      inputDisabled={true}
                    />
                  )),
              }
            : undefined,
        ]}
      />
    </div>
  );
};

PrescriptionsList.propTypes = {
  patient: PropTypes.object.isRequired,
  prescriptions: PropTypes.array.isRequired,
  renderDetails: PropTypes.func,
  hideRequests: PropTypes.bool,
};

export default PrescriptionsList;
